/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

export const TEST_CONFIG = {
  active: false,
  finished: true,
  alternatives: [
    'control',
    'b1_paper_in_header',
    'b2_paper_with_author_byline',
    'b3_library_value_prop',
    'b4_paper_thumbnail_above',
    'b5_paper_on_email_reg',
    'b6_paper_across_funnel',
    'c2_speed_subheader',
    'c3_almost_there_email_reg',
    'd1_download_oauth_labels',
    'd3_download_submit_label',
    'f1_email_button_on_top',
    'f2_no_facebook',
    'f4_google_only',
    'f5_google_only_with_paper_line',
    'h1_combo_paper_speed_google_download',
    'h2_paper_plus_speed',
    'h3_google_only_with_speed',
    'h4_your_paper_card_google_only',
    'h5_your_paper_card_three_methods',
  ],
  winner: 'control',
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * loswp_modal_autotest_2026_q2_v3
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base('loswp_modal_autotest_2026_q2_v3', TEST_CONFIG);
}

/**
 * React hook to return the bucket for this A/B test:
 * loswp_modal_autotest_2026_q2_v3
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base('loswp_modal_autotest_2026_q2_v3', TEST_CONFIG);
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * loswp_modal_autotest_2026_q2_v3
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base('loswp_modal_autotest_2026_q2_v3', TEST_CONFIG);
}

// MD5 hash of test's YAML config; modification will fail commit hook
// 64d31a3ad75784463ebf9f577f8e47f4
